import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createPinia } from 'pinia';

import { __ } from './mixins/__';
import { can } from './mixins/can';
import { hasRole } from './mixins/hasRole';
import { hasSubscription } from './mixins/hasSubscription';
import { isImage } from './mixins/isImage';
import { routes } from './routes';

import App from './App.vue';
import '/node_modules/@teamfurther/cinderblock/dist/cinderblock.css';

// Only import and initialize Bugsnag if in production environment
let bugsnagVue;

async function initBugsnag() {
    if (import.meta.env.VITE_APP_ENV === 'production') {
        const Bugsnag = (await import('@bugsnag/js')).default;
        const BugsnagPerformance = (await import('@bugsnag/browser-performance')).default;
        const BugsnagPluginVue = (await import('@bugsnag/plugin-vue')).default;

        Bugsnag.start({
            apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
            appVersion: import.meta.env.VITE_APP_VERSION,
            onError: function (event) {
                const originalError = event.originalError as any;

                if (
                    originalError?.response?.status === 401 ||
                    originalError?.response?.status === 404 ||
                    originalError?.response?.status === 422
                ) {
                    return false;
                }

                if (window.localStorage.getItem('user')) {
                    const user = JSON.parse(window.localStorage.getItem('user'));
                    event.setUser(user.id, user.email, user.name);
                }
            },
            plugins: [new BugsnagPluginVue()],
        });

        BugsnagPerformance.start({ apiKey: import.meta.env.VITE_BUGSNAG_API_KEY });

        bugsnagVue = Bugsnag.getPlugin('vue');
    }
    return bugsnagVue;
}

async function initApp() {
    // Initialize Bugsnag first
    await initBugsnag();

    const app = createApp(App);
    const router = createRouter({
        history: createWebHistory(),
        routes,
    });
    const pinia = createPinia();

    app.config.globalProperties.app = {
        name: import.meta.env.VITE_APP_NAME,
        version: import.meta.env.VITE_APP_VERSION,
    };

    // Only use Bugsnag in production
    if (import.meta.env.VITE_APP_ENV === 'production' && bugsnagVue) {
        app.use(bugsnagVue);
    }
    app.use(pinia);
    app.use(router);

    app.use(__);
    app.use(can);
    app.use(hasRole);
    app.use(hasSubscription);
    app.use(isImage);
    app.provide('__', app.config.globalProperties.__);
    app.provide('can', app.config.globalProperties.can);
    app.provide('hasRole', app.config.globalProperties.hasRole);
    app.provide('hasSubscription', app.config.globalProperties.hasSubscription);
    app.provide('isImage', app.config.globalProperties.isImage);

    app.mount('#app');
}

// Initialize the app
initApp();